module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/14527e39e3bb437ed1d580b612bab90a.png";